import {BettingPromotionModuleFetchHandler} from "./betting-promotion.module.fetch-handler";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {BettingPromotionModuleOnPopupClickHandler} from "./betting-promotion.module.on-popup-click.handler";
import {BettingPromotionModuleDisplayHandler} from "../../../../../core/handlers/betting-promotion/betting-promotion.module.display.handler";
import {BettingPromotionDisplayAnalyticsHandler} from "./betting-promotion.display-analytics.handler";
import {BettingPromotionClickAnalyticsHandler} from "./betting-promotion.click-analytics.handler";

export class BettingPromotionModuleHandlers extends HandlerList {

  static injectables = [
    BettingPromotionModuleFetchHandler,
    BettingPromotionModuleOnPopupClickHandler,
    BettingPromotionModuleDisplayHandler,
    BettingPromotionDisplayAnalyticsHandler,
    BettingPromotionClickAnalyticsHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    bettingPromotionModuleFetchHandler: BettingPromotionModuleFetchHandler,
    bettingPromotionModuleOnPopupClickHandler: BettingPromotionModuleOnPopupClickHandler,
    bettingPromotionModuleDisplayHandler: BettingPromotionModuleDisplayHandler,
    bettingPromotionDisplayAnalyticsHandler: BettingPromotionDisplayAnalyticsHandler,
    bettingPromotionClickAnalyticsHandler: BettingPromotionClickAnalyticsHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      bettingPromotionModuleFetchHandler,
      bettingPromotionModuleOnPopupClickHandler,
      bettingPromotionModuleDisplayHandler,
      bettingPromotionDisplayAnalyticsHandler,
      bettingPromotionClickAnalyticsHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
